import { useState, useContext, useEffect } from 'react'
import { DContext } from '../../context/Datacontext'
import { BsFillPersonPlusFill } from "react-icons/bs";
import AccountCreate from './Organisation/AccountCreate';
import { fetchUsersCreate } from '../services/fetchUsersCreate';
import { useNavigate } from 'react-router-dom';
import { compressImage } from '../../utils/compressImages';

const UsersAccountCreate = () => {

    const { currentUser, BeURL, showAlert } = useContext(DContext)

    const navigate = useNavigate()

    const [profileFile, setProfileFile] = useState(null);
    const [users, setUsers] = useState({
        firstName: '',
        lastName: '',
        fullName: '',
        email: '',
        alternateEmail: '',
        contact: '',
        alternateContact: '',
        companyId: '',
        empId: '',
        role: '',
        password: '',
        confirmPwd: ''
    })

    const [reportingMates, setReportingMates] = useState({
        reportingManagerId: '',
        reportingTeamLeadIds: ''
    })
    const [errors, setErrors] = useState({
        users: {}
    });

    const isFormValid = (errors) => {
        // Check if all error objects are empty
        return (
            Object.values(errors.users || {}).every((err) => !err)
        )
    }

    const handleCreate = async () => {
        // Users
        const formData = new FormData()
        formData.append('firstName', users.firstName)
        formData.append('lastName', users.lastName)
        formData.append('fullName', users.fullName)
        formData.append('email', users.email)
        formData.append('alternateEmail', users.alternateEmail)
        formData.append('contact', users.contact)
        formData.append('empId', users.empId)
        formData.append('alternateContact', users.alternateContact)
        formData.append('selectedRole', currentUser.role === 'teamlead' ? 'recruiter' : users.role)
        formData.append('password', users.password)
        // file image 

      
        if (profileFile) {
            const compressedFile = await compressImage(profileFile, { maxSizeMB: 0.7 });
            if (compressedFile) {
                formData.append("profile", compressedFile);
            }
         
        }

        if (currentUser.role === 'admin') {
            if (["teamlead", "recruiter"].includes(users.role)) {
                formData.append('reportingManagerId', reportingMates.reportingManagerId)
            }

            if (users.role === 'recruiter')
                formData.append('reportingTeamLeadId', reportingMates.reportingTeamLeadIds)
        }

        if (currentUser.role === 'manager') {
            if (["teamlead", "recruiter"].includes(users.role)) {
                formData.append('reportingManagerId', currentUser.id)
            }

            if (users.role === 'recruiter')
                formData.append('reportingTeamLeadId', reportingMates.reportingTeamLeadIds)
        }

        if (currentUser.role === 'teamlead') {
            if (users.role === 'recruiter')
                formData.append('reportingManagerId', currentUser.reportingManager.reporingManagerId)
            formData.append('reportingTeamLeadId', currentUser.id)
        }

        await fetchUsersCreate(BeURL, showAlert, formData, currentUser?.company?.companyId, setUsers, setReportingMates)

    }

    return (
        <main className="min-h-[85vh] flex items-center justify-center  px-4 py-3">
            <div className="w-full  bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-200">
                {/* Header Section */}
                <div className="bg-secondary-500 py-2 px-4 text-center">
                    <div className="flex justify-center">
                        <div className="p-3 rounded-full bg-white text-secondary-500 shadow-md">
                            <BsFillPersonPlusFill className="text-xl" />
                        </div>
                    </div>
                    <h2 className="mt-3 text-xl font-bold text-white">
                        Create Users Account
                    </h2>
                    <p className="mt-1 text-sm text-secondary-100">
                        Fill in the details below to get started
                    </p>
                </div>

                {/* Form Section */}
                <div className="p-8 sm:p-10">
                    <AccountCreate
                        users={users}
                        setUsers={setUsers}
                        errors={errors}
                        setErrors={setErrors}
                        profileFile={profileFile}
                        setProfileFile={setProfileFile}
                        currentUser={currentUser}
                        reportingMates={reportingMates}
                        setReportingMates={setReportingMates}
                    />
                </div>

                    <div className='flex justify-end md:px-32 pb-5 gap-3'>
                        <button
                        type='button'
                        onClick={()=>window.location.href = "/"}
                        className= "border px-3 text-primary-400 border-primary-400 rounded-lg"
                        >Back</button>

                        <button
                            type="submit"
                            disabled={!isFormValid(errors)}
                            className={`px-4 py-2 rounded ${isFormValid(errors)
                                ? "bg-secondary-200 text-white hover:bg-secondary-500 rounded-lg"
                                : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                            onClick={handleCreate}
                        >
                            Create Account
                        </button>

                    </div>

            </div>


        </main>

    )

}

export default UsersAccountCreate